import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import TravelTransactionDetailsSkeletonWeb from "./layouts/TravelTransactionDetailsSkeleton.web";
import TravelTransactionDetailsSkeletonMob from "./layouts/TravelTransactionDetailsSkeleton.mob";

const TravelTransactionDetailsSkeletonComponent = withConditionalComponent(TravelTransactionDetailsSkeletonWeb, TravelTransactionDetailsSkeletonMob);

export default function TravelTransactionDetailsSkeleton() {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <TravelTransactionDetailsSkeletonComponent trigger={isLargeScreen} />;
}
